//
//현재 사용 안함
//
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // useNavigate 추가
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';

export default function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate(); // useNavigate 훅 사용

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('이메일과 비밀번호를 입력하세요.');
        } else {
            setError('');
            // 로그인 로직 추가 (예: API 호출)
            const isLoginSuccessful = true; // 예시
            if (isLoginSuccessful) {
                navigate('/dashboard'); // 로그인 성공 시 대시보드로 이동
            } else {
                setError('로그인에 실패했습니다. 이메일과 비밀번호를 확인하세요.');
            }
        }
    };

    const handleSignUp = () => {
        navigate('/register'); // /register 경로로 이동
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">
            <Row className="justify-content-md-center w-100">
                <Col md={6}>
                    <h2 className="text-center">Login</h2>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="formEmail" className="mb-3">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                type="email"
                                placeholder="Enter email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group controlId="formPassword" className="mb-3">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                type="password"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Group>

                        <Button variant="primary" type="submit" className="w-100 mb-2">
                            Login
                        </Button>
                        <Button
                            variant="secondary"
                            type="button"
                            className="w-100"
                            onClick={handleSignUp}
                        >
                            Sign Up
                        </Button>
                    </Form>
                    <div className="text-center mt-3">
                        <a href="/forgot-password" className="text-muted">비밀번호를 잊으셨나요?</a>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};